import React from "react";

export const IsActive = (props) => {
  if (props.value) {
    return (
      <i
        className={`fas fa-check-circle color-promotion ${props.className}`}></i>
    );
  } else {
    return (
      <i className={`fas fa-times-circle color-red ${props.className}`}></i>
    );
  }
};
